require('./bootstrap');

$('.datepicker > input').daterangepicker({
	"singleDatePicker": true,
	"timePicker": false,
	"autoUpdateInput": false,
	"autoApply": true,
	"showDropdowns": true,

	"locale": {
		"format": "DD.MM.YYYY",
		"firstDay": 1
	}
});

$('.datepicker > input').on('apply.daterangepicker', function (ev, picker) {
	$(this).val(picker.startDate.format('DD.MM.YYYY'));
});

$('[data-toggle="popover"]').popover({
	container: 'body'
});

$('.showLengthLeft').keyup(function () {
	var obj = $(this).find('textarea');
	var max = obj.attr('maxlength');	
	var val = obj.val();
	var len = val.length;
	if (len >= max) {
		$(this).find('.charNum').html('0 characters available');
	} else {
		var char = max - len;
		val = val.substring(0, max);
		$(this).find('.charNum').html(char + ' characters available');
		obj.val(val);
	}
}).each(function () {
	var obj = $(this).find('textarea');
	var max = obj.attr('maxlength');	
	var len = obj.val().length;
	var char = max - len;
	$(this).prepend('<small class="float-right charNum mt-2 text-muted">' + char + ' characters available</small>');
});


setBtnLoading = function(btn, disabled) {
	if(disabled) {
		btn.prop('disabled', disabled).prepend('<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>');	
	} else {
		btn.prop('disabled', disabled).find('.spinner-border').remove();
	}
}


$(document).on('mouseover', '.openSupporterModal', function() {
	$(this).addClass('shadow');
}).on('mouseout', '.openSupporterModal', function() {
	$(this).removeClass('shadow');
});
$(document).on('click', '.openSupporterModal', function() {
	$('#supporterModal').find('.h3').html($(this).find('h3').html());
	$('#supporterModal').find('.h3').html($(this).find('h3').html());
	$('#supporterModal').find('.h3').html($(this).find('h3').html());
	var img = $(this).find('img');
	$('#supporterModal').find('img').prop('src', img.prop('src')).prop('alt', img.prop('alt')).prop('title', img.prop('title'));
	$('#supporterModal').find('.text-uppercase').html($(this).find('.text-uppercase').html());
	$('#supporterModal').find('em').html($(this).find('em').html());
	$('#supporterModal').modal('show');
});		